module.exports = __webpack_public_path__ + "img/stand_xiaoman_2.6a993fc7.jpg";